import React from "react";
import { Container, Grid } from "@mui/material";
import Modal from "@mui/material/Modal";
import "./warningModal.scss";
import warning from "../../../assets/authentication-imgs/warning.svg";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import WarningModal from "./warningModal";

interface IMODAL {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  openModal: boolean;
  noOfAttempts:any
}
const AttempsRemaining: React.FC<IMODAL> = (props) => {
  return (
    <div className="login-modal">
      <WarningModal
        setOpenModal={props.setOpenModal}
        openModal={props.openModal}
        image={warning}
        text={
          `Sign in details are incorrect, please check and try again. Attempts Remaining ${
            4 - props.noOfAttempts
          }`
        }
      />
    </div>
  );
};

export default AttempsRemaining;
